exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-top-text .checkbox-fade label {\n    margin: 0;\n}\n\n.header-top-text input[type=\"text\"] {\n    width: 100%;\n    max-width: 50%;\n}\n.header-top-text label {\n    font-weight: bold;\n    display: block;\n}\n.header-top-text .form-group {\n    padding-bottom: 20px;\n}\n.type-img img {\n    width: 100%;\n    max-width: 200px;\n    display: block;\n    margin: 0 auto;\n    min-height: 200px;\n    max-height: 200px;\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n\n.m-b-0 {\n\tmargin: 0;\n}\n.m-t-15 {\n\tmargin-top:15px;\n}\n.header-top-text label.ng-star-inserted,\n.header-top-text label.l_visi {\n    display: block;\n    clear: both;\n    padding-top: 5px;\n}\n.header-top-text input[type=\"text\"] {\n    vertical-align: top;\n    margin-top: 15px;\n}\n.header-top-text .checkbox-fade {\n    min-width: 100px;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/layout/splash-footer/splash-footer.component.css
// module id = ../../../../../src/app/layout/splash-footer/splash-footer.component.css
// module chunks = main